var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPoint = function SvgPoint(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15.559,
    fill: "currentColor",
    fillOpacity: 0.279,
    stroke: "currentColor",
    opacity: 0.99
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 1.915,
    fill: "#f9f9f9",
    fillOpacity: 0.99,
    stroke: "#ececec",
    opacity: 0.99
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPoint);
export default ForwardRef;